import { Microphone } from '@tunasong/icons'
import { logger } from '@tunasong/models'
import type { Entity, Persisted } from '@tunasong/schemas'
import type { FabProps } from '@tunasong/ui-lib'
import { Dialog, Typography, isMobileDevice, useUploadStoredEntity, Fab } from '@tunasong/ui-lib'
import { useState, type MouseEvent } from 'react'
import AudioRecorder from './audio-recorder.js'
import styles from './record-fab.module.css'

export interface RecordFabButtonProps extends Omit<FabProps, 'onClick' | 'position'> {
  parent?: Persisted<Entity>
  position?: 'fixed' | 'relative'
}

export const RecordFabButton = (props: RecordFabButtonProps) => {
  const { parent, ...restProps } = props

  const { uploadNewEntity, isUploading } = useUploadStoredEntity()

  const [open, setOpen] = useState(false)

  const handleComplete = (name: string, audio: Blob) => {
    setOpen(false)

    // The upload manager tells the user when an upload is refused or fails
    uploadNewEntity({ name, parentId: parent?.id ?? null, blob: audio }).catch(e =>
      logger.warn('Recording upload failed', e)
    )
  }

  const handleClick = (ev: MouseEvent) => {
    ev.stopPropagation()
    setOpen(true)
  }

  return (
    <>
      <Dialog fullScreen={isMobileDevice()} open={open} onClose={() => setOpen(false)} title="Record Audio">
        <Typography variant="caption" className={styles.caption}>
          Tap the Start Recording. Tap again to stop. When you're done, tap "Save Recording" to upload.
        </Typography>
        <AudioRecorder style={{ height: '100%' }} parentEntity={parent} onComplete={handleComplete} />
      </Dialog>
      <Fab aria-label="Record" disabled={isUploading} onClick={handleClick} {...restProps}>
        <Microphone />
      </Fab>
    </>
  )
}
